<template>
  <span>
    <input
      :value="value"
      class="input w-100 px-4 py-2 my-2 small"
      :class="{ error }"
      :type="type"
      :placeholder="placeholder"
      :autocomplete="type == 'password' ? 'current-password' : ''"
      @input="input($event)"
      @blur="$emit('blur', $event)"
    />
    <div v-for="(e, i) in errors" :key="i">
      <MessageError class="ml-3">{{ e }}</MessageError>
    </div>
  </span>
</template>

<script>
import MessageError from 'UI/MessageError';
export default {
  components: {
    MessageError
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  computed: {
    error() {
      return this.errors.length > 0;
    }
  },
  methods: {
    input($event) {
      this.$emit('input', $event.target.value);
      this.$emit('change', $event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  border: 2px solid $lightGray;
  border-radius: 8px;
  &.error {
    border: 1px solid red;
  }
}
.input::placeholder {
  color: #1d1d1d;
  font-weight: 500;
}
</style>
